import type { ReactNode } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ptBR } from "@mui/x-date-pickers/locales";
import "dayjs/locale/pt-br";

// Seletores de data e hora do MUI no padrão brasileiro: adapterLocale formata (DD/MM/AAAA, 24h) e
// localeText traduz os textos (Cancelar, OK...). Os campos genéricos também se envolvem nele, para
// valer fora do App (testes, telas montadas sozinhas).
export function PickersPtBr({ children }: { children: ReactNode }) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-br"
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      {children}
    </LocalizationProvider>
  );
}
